import { EducationModule } from "@js/components/EducationCourse/eduConfig";
import { level1ModuleCompleteColor } from "@js/educationContent/CairoMummiesContent/eduConstants";
import Ribbon0 from "@js/public/images/Ribbon0.svg";
import StarklingsLogo from "@js/public/images/StarklingsLogo.svg";
import {
    lesson0DefaultEndCode,
    lesson0DefaultMiddleCode,
    lesson0DefaultStartCode,
} from "./lesson0";
import {
    lesson1DefaultEndCode,
    lesson1DefaultMiddleCode,
    lesson1DefaultStartCode,
} from "./lesson1";
import {
    lesson2DefaultEndCode,
    lesson2DefaultMiddleCode,
    lesson2DefaultStartCode,
} from "./lesson2";
import {
    lesson3DefaultEndCode,
    lesson3DefaultMiddleCode,
    lesson3DefaultStartCode,
} from "./lesson3";
import { m2l0Solution } from "./lesson0Solution";
import { m2l1Solution } from "./lesson1Solution";
import { m2l2Solution } from "./lesson2Solution";
import { m2l3Solution } from "./lesson3Solution";

export const starklings1PrimitiveTypesConfig: EducationModule = {
    solution: "",
    imgSrc: StarklingsLogo.src,
    moduleInfo: {
        id: 2,
        moduleName: "starklings1PrimitiveTypes",
        timeEstimate: "20-25 min",
        title: "Starklings 1.0 Primitive Types",
        description: `Welcome to the intro of Starklings 1.0 Primitive Types lessons. Good luck!`,
        moduleComplete: {
            badgeName: "STARKLINGS 1.0 PRIMITIVE TYPES",
            badgeCaption: "A level 1 Starkling 1.0",
            ribbonImgSrc: Ribbon0.src,
            badgeImgSrc: StarklingsLogo.src,
            imgColor: level1ModuleCompleteColor,
            badgeTokenId: 15,
        },
    },
    lessons: [
        {
            timeEstimate: "5 min",
            title: "PrimitiveTypes00",
            formattedDescription: `
[ { "type": "paragraph", "children": [ { "text": "Cairo has a couple of basic types that are directly implemented into the compiler. In this section, we'll go through the most important ones." } ] }, { "type": "paragraph", "children": [ { "text": "" }, { "type": "link", "url": "https://cairo-book.github.io/ch02-02-data-types.html", "children": [ { "text": "Data Types" } ] }, { "text": "" } ] } ]
`,
            hints: [],
            defaultStartCode: lesson0DefaultStartCode,
            defaultMiddleCode: lesson0DefaultMiddleCode,
            defaultEndCode: lesson0DefaultEndCode,
            id: 0,
            solution: m2l0Solution,
        },
        {
            timeEstimate: "5 min",
            title: "PrimitiveTypes01",
            formattedDescription: `
[ { "type": "paragraph", "children": [ { "text": "Cairo has a couple of basic types that are directly implemented into the compiler. In this section, we'll go through the most important ones." } ] }, { "type": "paragraph", "children": [ { "text": "" }, { "type": "link", "url": "https://cairo-book.github.io/ch02-02-data-types.html", "children": [ { "text": "Data Types" } ] }, { "text": "" } ] } ]
`,
            hints: [],
            defaultStartCode: lesson1DefaultStartCode,
            defaultEndCode: lesson1DefaultEndCode,
            defaultMiddleCode: lesson1DefaultMiddleCode,
            id: 1,
            solution: m2l1Solution,
        },
        {
            timeEstimate: "5 min",
            title: "PrimitiveTypes02",
            formattedDescription: `
[ { "type": "paragraph", "children": [ { "text": "Cairo has a couple of basic types that are directly implemented into the compiler. In this section, we'll go through the most important ones." } ] }, { "type": "paragraph", "children": [ { "text": "" }, { "type": "link", "url": "https://cairo-book.github.io/ch02-02-data-types.html", "children": [ { "text": "Data Types" } ] }, { "text": "" } ] } ]
`,
            hints: [],
            defaultStartCode: lesson2DefaultStartCode,
            defaultMiddleCode: lesson2DefaultMiddleCode,
            defaultEndCode: lesson2DefaultEndCode,
            id: 2,
            solution: m2l2Solution,
        },
        {
            timeEstimate: "5 min",
            title: "PrimitiveTypes03",
            formattedDescription: `
[ { "type": "paragraph", "children": [ { "text": "Cairo has a couple of basic types that are directly implemented into the compiler. In this section, we'll go through the most important ones." } ] }, { "type": "paragraph", "children": [ { "text": "" }, { "type": "link", "url": "https://cairo-book.github.io/ch02-02-data-types.html", "children": [ { "text": "Data Types" } ] }, { "text": "" } ] } ]
`,
            hints: [],
            defaultStartCode: lesson3DefaultStartCode,
            defaultMiddleCode: lesson3DefaultMiddleCode,
            defaultEndCode: lesson3DefaultEndCode,
            id: 3,
            solution: m2l3Solution,
        },
    ],
};
